export default "__VITE_ASSET__220f899b__"